import { createRouter, createWebHistory } from 'vue-router';

import Reports from '@/components/Reports/Reports.vue';

import Main from '../components/Main.vue';
import ArchivedContainers from '../components/ContainerTracker/ArchivedContainers.vue';
import EmptyReturns from '../components/ContainerTracker/Empty/EmptyReturns.vue';

import Login from '../components/auth/Login.vue';
import Landing from '../components/Landing/Landing.vue';
import Admin from '../components/Admin/Admin.vue';
const Billing = () => import('../components/Billing/Billing.vue');
const Invoices = () => import('../components/Billing/Invoices.vue');
const Rates = () => import('../components/Billing/MyRates.vue');
const OrderInvoice = () => import('../components/Billing/OrderInvoice.vue');
import Profile from '../components/Profile/Profile.vue';
import Payments from '../components/Payment/Payments.vue';
import Customers from '../components/Customer/Customers.vue';
import Orders from '../components/Orders/Orders.vue';
import OrderDetails from '../components/Orders/OrderDetails.vue';
import NewOrderPage from '../components/Orders/NewOrderPage.vue';
import Dispatch from '../components/Dispatch/Dispatch.vue';


import DirectoryBasePage from '../components/Directory/DirectoryBasePage.vue';
import DirectoryCityPage from '../components/Directory/DirectoryCityPage.vue';
import CompanyInfoPage from '../components/Directory/CompanyInfoPage.vue';

import OrderBLPrint from '../components/Orders/OrderBLPrint.vue';
import OrderDispatchPrint from '../components/Orders/OrderDispatchPrint.vue';
import OrderCoverPrint from '../components/Orders/OrderCoverPrint.vue';
import OrderStatus from '../components/Orders/External/OrderStatus.vue';
import OrdersStatus from '../components/Orders/External/OrdersStatus.vue';

import OnboardingFormView from '../components/Onboarding/OnboardingFormView.vue';
import OnboardingComplete from '../components/Onboarding/OnboardingComplete.vue';

import CarriersView from '../components/Onboarding/Carriers.vue';
import ShareableProfilePage from '../components/Profile/ShareableProfilePage.vue';

import LoadsView from '../components/PODTracking/LoadsView.vue';

import Chat from '../components/Comms/Chat.vue';

import { ROUTE_NAMES } from './route_utils';
import { pinia } from '@/stores/pinia';
import { useAuthStore } from '@/stores/auth';


const routesList: Array<any> = [
  // Landing
  {
    path: '/',
    name: 'Landing',
    component: Landing,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false,
      isLogin: true,
    },
  },
  {
    path: '/emptyreturns',
    name: 'EmptyReturnsPage',
    component: EmptyReturns,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: `${ROUTE_NAMES.DIRECTORY}`,
    name: 'Directory Base - All Cities',
    component: DirectoryBasePage,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: `${ROUTE_NAMES.DIRECTORY}/:cityName`,
    name: 'City Directory',
    component: DirectoryCityPage,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
    props: (route: any) => ({ cityName: route.params.cityName }),
  },
  {
    path: `${ROUTE_NAMES.COMPANY}/:companyId`,
    name: 'Company page',
    component: CompanyInfoPage,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
    props: (route: any) => ({ companyId: parseInt(route.params.companyId, 10) }),
  },
  {
    path: '/empties',
    name: 'EmptiesRedirect',
    redirect: '/emptyreturns',
  },
  {
    path: '/tracking/:containerId?',
    name: 'Tracking',
    component: Main,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/archived/:containerId?',
    name: 'Archived',
    component: ArchivedContainers,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/rates',
    name: 'Rates',
    component: Rates,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/admin',
    name: '/Admin',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      isLogin: false,
    },
  },
  {
    path: '/billing/:id?',
    name: 'Billing',
    component: Billing,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/invoices/:id?',
    name: 'Invoices',
    component: Invoices,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/payments',
    name: 'Payments',
    component: Payments,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/orders',
    name: 'Orders List',
    component: Orders,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/orders/:id',
    name: 'Orders Details',
    component: OrderDetails,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
    props: (route: any) => ({ orderId: parseInt(route.params.id, 10) }),
  },
  {
    path: '/orders/new',
    name: 'Orders New',
    component: NewOrderPage,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/dispatch/',
    name: 'Dispatch',
    component: Dispatch,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/drivers',
    name: 'Drivers',
    redirect: '/profile',
  },
  {
    path: '/trucks',
    name: 'Trucks',
    redirect: '/profile',
  },
  {
    path: '/customers/:id?',
    name: 'Customers',
    component: Customers,
    props: {
      module: 'Contrak',
    },
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },

  {
    path: '/Loads',
    name: 'POD Tracking Loads',
    component: LoadsView,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/onboarding/complete',
    name: 'Onboarding Complete Page',
    component: OnboardingComplete,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: '/onboarding/:userCompanyId/:carrierCompanyId',
    name: 'Onboarding Form',
    component: OnboardingFormView,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: '/carriers',
    name: 'Carrier Onboarding',
    component: CarriersView,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: '/profile/:companyId',
    name: 'My Info Page',
    component: ShareableProfilePage,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: '/settlements',
    name: 'My Info Page',
    component: Billing,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },

  // DocGen routes
  {
    path: '/print/order/bl/:id/container/:containerIdx',
    name: 'Print Orders BL',
    component: OrderBLPrint,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/print/order/dispatch/:id/container/:containerId/trip/:tripId',
    name: 'Print Order Dispatch',
    component: OrderDispatchPrint,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/print/order/cover/:id',
    name: 'Print Orders',
    component: OrderCoverPrint,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },
  {
    path: '/print/invoice/order/preview/:id',
    name: 'Preview Order Invoice',
    component: OrderInvoice,
    meta: {
      requiresAuth: true,
      isLogin: false,
    },
  },

  // External Facing routes
  {
    path: '/status/order/:hash',
    name: 'OrderStatus',
    component: OrderStatus,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: '/status/orders/:hash',
    name: 'OrderStatus',
    component: OrdersStatus,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  },
  { 
    path: '/:pathMatch(.*)*', 
    redirect: '/' 
  },
];

// Dev-only component playground route
// vue-cli-service serve → sets NODE_ENV = 'development'
// (whereas vue-cli-service build → sets NODE_ENV = 'production')
if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_COMPONENT_PLAYGROUND === '1') {
  const ComponentPlayground = () => import('../components/dev/ComponentPlayground.vue');
  const FaIconsSamples = () => import('../components/UI/FaIconsSamples.vue');
  // Insert before the catch-all so it actually resolves
  routesList.splice(routesList.length - 1, 0, {
    path: '/dev/playground',
    name: 'Component Playground',
    component: ComponentPlayground,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  }, {
    path: '/dev/fa-icons',
    name: 'Font Awesome Icon Samples',
    component: FaIconsSamples,
    meta: {
      requiresAuth: false,
      isLogin: false,
    },
  }, );
}

const router = createRouter({
  history: createWebHistory(),
  routes: routesList
});

router.beforeEach(async (to, from, next) => {
  document.title = 'EzModal';
  const auth = useAuthStore(pinia);
  if (!auth.hydrated) {
    auth.hydrateFromStorage();
    await auth.refreshRoles(true);
  }

  if (to.matched.some((record) => record.meta.isLogin)) {
    if (auth.isAuthenticated) {
      return next('/');
    } else {
      return next();
    }
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth.isAuthenticated) {
      return next('/login');
    }
  }

  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    if (!auth.isAuthenticated) {
      return next('/login');
    }

    // Roles are refreshed from the backend and cached in the auth store.
    const canAccessAdmin = await auth.refreshRoles(true);
    if (!canAccessAdmin) {
      return next('/tracking');
    }
  }

  return next();
});

export default router;